import React, { useEffect, useState, useMemo } from "react";

import face3 from "../../assets/images/faces/12.jpg";
import face4 from "../../assets/images/faces/13.jpg";
import face5 from "../../assets/images/faces/14.jpg";
import axios from "axios";
import Spinner from "../Spinner/spinner";
import Cookies from "js-cookie";
import api from "../../api";
import messagesImg from "../../assets/images/no-message.png";
import useInboundSocket from "../../hooks/useInboundSocket";
const baseUrl = process.env.REACT_APP_BASE_URL;
const LeftCard = ({
  onSelectConversation,
  selectedConversation,
  onLoaded,
  conversationId,
}) => {
  const [languageData, setLanguageData] = useState(null);
  const [typingUser, setTypingUser] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [showSpinner, setShowSpinner] = useState(false);
  const [experts, setExperts] = useState([]);

  useEffect(() => {
    if (!conversationId || conversations.length === 0) return;

    const selected = conversations.find(
      (item) => item.id === Number(conversationId),
    );

    if (selected) {
      onSelectConversation(selected);
    }
  }, [conversationId, conversations]);

  const fetchedData = async () => {
    try {
      const response = await api.get(`/messaging/conversations/list`);

      setConversations(response.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      onLoaded();
    }
  };

  const fetchExperts = async () => {
    try {
      setShowSpinner(true);

      const response = await api.get(`/content/experts/list`);
      const data = response.data.data || [];

      setExperts(data);
    } catch (error) {
      console.error("Error fetching experts:", error);
    } finally {
      setShowSpinner(false);
    }
  };

  useEffect(() => {
    fetchExperts();
  }, []);
  const getInboundExtensions = (experts = []) => {
    const extensionsSet = new Set();

    experts.forEach((expert) => {
      expert.services?.forEach((service) => {
        if (service.call_type === "prn" || service.call_type === "credit") {
          service.extensions?.forEach((ext) => {
            if (ext.type === "inbound" && ext.data) {
              extensionsSet.add(ext.data);
            }
          });
        }
      });
    });

    return Array.from(extensionsSet);
  };
  const inboundExtensions = useMemo(() => {
    return getInboundExtensions(experts);
  }, [experts]);

  const inboundStatuses = useInboundSocket(inboundExtensions);
  const getInboundExtension = (expert) => {
    return expert.services
      ?.flatMap((s) => s.extensions || [])
      ?.find((e) => e.type === "inbound")?.data;
  };

  const isExpertOnline = (expert) => {
    if (!inboundStatuses) return false;

    const extension = getInboundExtension(expert);
    if (!extension) return false;

    const status = inboundStatuses[String(extension)];

    return status?.label === "Idle";
  };
  const expertsMap = useMemo(() => {
    const map = {};
    experts.forEach((e) => {
      map[String(e.id)] = e;
    });
    return map;
  }, [experts]);

  const onlineConversations = useMemo(() => {
    if (!inboundStatuses) return [];

    return conversations.filter((conv) => {
      const fullExpert = expertsMap[String(conv.id)];

      return fullExpert && isExpertOnline(fullExpert);
    });
  }, [conversations, expertsMap, inboundStatuses]);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/messages/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
    fetchedData();
  }, []);
  const openConversationByExpert = (expert) => {
    document.querySelector(".chat-footer").classList.remove("hidden");
    const conversation = conversations.find((c) => c.expert?.id === expert.id);

    if (conversation) {
      onSelectConversation(conversation);
    } else {
      const tempConversation = {
        id: `${expert.id}`,
        expert: expert,
        messages: [],
        status: "new",
      };

      onSelectConversation(tempConversation);
    }
  };
  const filteredConversations = useMemo(() => {
    const today = new Date().toDateString();

    return conversations.filter((conversation) => {
      return (
        new Date(conversation.date).toDateString() === today ||
        (conversation.last_message.sender === 2 &&
          conversation.status === "received")
      );
    });
  }, [conversations]);

  if (!languageData) {
    return <div></div>;
  }

  const handleTyping = (userName) => {
    setTypingUser(userName);
  };

  return (
    <>
      <div className="chat-info border text-start">
        <div className="d-flex align-items-center justify-content-between w-100 p-3 border-bottom">
          <div>
            <h5 className="fw-semibold mb-0">{languageData.title}</h5>
          </div>
        </div>

        {/*   <div className="chat-search p-3 border-bottom">
          <div className="input-group">
            <input
              type="text"
              name="search"
              className="form-control"
              placeholder={languageData.search}
              aria-describedby="button-addon2"
              onFocus={() => handleTyping("Alice Johnson")}
              onBlur={() => setTypingUser(null)}
            />
            <button data-interaction="search_message"
              aria-label="button"
              type="button"
              className="btn btn-primary-light btn-wave waves-effect waves-light"
              id="button-addon2"
            >
              <i className="ri-search-line"></i>
            </button>
          </div>
        </div> */}

        <div className="align-items-center justify-content-between w-100 p-3 border-bottom">
          <div>
            <h6 className="fw-semibold mb-0">{languageData.online}</h6>
          </div>
          <div className="mt-3">
            {experts.map((expert, index) => {
              const online = isExpertOnline(expert);

              return (
                <a
                  data-interaction="expert_img"
                  data-expert={`${expert.id}`}
                  key={index}
                  className={`pointer avatar avatar-md me-2 avatar-rounded checkforactive ${
                    selectedConversation?.id === expert.id ? "active-chat" : ""
                  } ${online ? "offline" : "offline"}`}
                  title={expert.nickname}
                  onClick={(e) => {
                    e.preventDefault();
                    openConversationByExpert(expert);
                  }}
                >
                  <img src={expert.image} alt={expert.nickname} />
                </a>
              );
            })}
          </div>
        </div>

        <ul
          className="nav nav-tabs tab-style-6 p-0 nav-justified mb-0 border-bottom d-block d-sm-flex rounded-0"
          id="myTab1"
          role="tablist"
        >
          <li className="nav-item" role="presentation">
            <button
              data-interaction="active_chat_tab_button"
              className="nav-link fs-14 active"
              id="active-tab"
              data-bs-toggle="tab"
              data-bs-target="#active-tab-pane"
              type="button"
              role="tab"
              aria-controls="active-tab-pane"
              aria-selected="true"
            >
              <i className="fe fe-mail me-1 align-middle d-inline-block"></i>
              {languageData.active_chats}
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              data-interaction="all_chat_tab_button"
              className="nav-link fs-14"
              id="all-tab"
              data-bs-toggle="tab"
              data-bs-target="#all-tab-pane"
              type="button"
              role="tab"
              aria-controls="all-tab-pane"
              aria-selected="false"
            >
              <i className="fe fe-users me-1 align-middle d-inline-block"></i>
              {languageData.all_chats}
            </button>
          </li>
        </ul>

        <div className="tab-content overflow-y" id="myTabContent">
          <div
            className="tab-pane fade show active border-0 chat-active-tab"
            id="active-tab-pane"
            role="tabpanel"
            aria-labelledby="active-tab"
            tabIndex="0"
          >
            <ul className="list-unstyled mb-0 mt-2 chat-users-tab resp-mx-h-inbox">
              {filteredConversations.length > 0 ? (
                filteredConversations.map((user, index) => (
                  <li
                    key={index}
                    className={`checkforactive ${
                      selectedConversation?.id === user.id ? "active-chat" : ""
                    }`}
                  >
                    <a
                      data-interaction="conversation_active_chat_tab"
                      data-expert={`${user.id}`}
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        onSelectConversation(user);
                      }}
                    >
                      <div className="d-flex align-items-top">
                        <div className="me-1 lh-1">
                          <span
                            className={`avatar avatar-md me-2 avatar-rounded ${user.status}`}
                          >
                            <img
                              src={user.expert.image}
                              alt={user.expert.nickname}
                            />
                          </span>
                        </div>
                        <div className="flex-fill">
                          <p className="mb-0 fw-semibold">
                            {user.expert.nickname}
                            {/*  <span className="float-end text-muted fw-normal fs-11">
                              {user.date}
                            </span> */}
                          </p>
                          <p className="fs-12 mb-0">
                            {user.last_message.seen === "typing" ? (
                              <span className="chat-msg">Typing...</span>
                            ) : (
                              <span
                                className="chat-msg text-truncate"
                                style={
                                  user.last_message.seen === false
                                    ? { fontWeight: "bold" }
                                    : {}
                                }
                              >
                                {user.last_message.content}
                              </span>
                            )}
                            <span className="chat-read-icon float-end align-middle text-muted">
                              {languageData.send}
                            </span>
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                ))
              ) : (
                <div className="d-flex flex-column align-items-center justify-content-center p-6">
                  <div class="empty_message">
                    <svg
                      width="80"
                      height="80"
                      viewBox="0 0 80 80"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <circle cx="40" cy="40" r="36" fill="#F3F0FF"></circle>
                      <rect
                        x="18"
                        y="24"
                        width="32"
                        height="20"
                        rx="9"
                        fill="#ffffff"
                        stroke="#7C3AED"
                        stroke-width="1.4"
                      ></rect>
                      <circle
                        cx="27"
                        cy="34"
                        r="2.2"
                        fill="#7C3AED"
                        opacity=".4"
                      ></circle>
                      <circle
                        cx="34"
                        cy="34"
                        r="2.2"
                        fill="#7C3AED"
                        opacity=".4"
                      ></circle>
                      <circle
                        cx="41"
                        cy="34"
                        r="2.2"
                        fill="#7C3AED"
                        opacity=".4"
                      ></circle>
                      <path
                        d="M24 44l-4 6 8-3"
                        fill="#ffffff"
                        stroke="#7C3AED"
                        stroke-width="1.3"
                        stroke-linejoin="round"
                      ></path>
                      <rect
                        x="34"
                        y="46"
                        width="26"
                        height="16"
                        rx="8"
                        fill="#EDE9FE"
                        stroke="#7C3AED"
                        stroke-width="1.4"
                      ></rect>
                      <circle
                        cx="42"
                        cy="54"
                        r="1.8"
                        fill="#7C3AED"
                        opacity=".5"
                      ></circle>
                      <circle
                        cx="47"
                        cy="54"
                        r="1.8"
                        fill="#7C3AED"
                        opacity=".5"
                      ></circle>
                      <circle
                        cx="52"
                        cy="54"
                        r="1.8"
                        fill="#7C3AED"
                        opacity=".5"
                      ></circle>
                      <path
                        d="M56 62l4 5-7-2"
                        fill="#EDE9FE"
                        stroke="#7C3AED"
                        stroke-width="1.3"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <span class="empty_message_title">
                      {languageData.no_message}
                    </span>
                  </div>
                </div>
              )}
            </ul>
          </div>
          <div
            className="tab-pane fade border-0 chat-all-tab"
            id="all-tab-pane"
            role="tabpanel"
            aria-labelledby="all-tab"
            tabIndex="0"
          >
            <ul className="list-unstyled mb-0 mt-2 chat-users-tab resp-mx-h-inbox">
              {conversations.length > 0 ? (
                conversations.map((user, index) => (
                  <li
                    key={index}
                    className={`checkforactive ${
                      selectedConversation?.id === user.id ? "active-chat" : ""
                    }`}
                  >
                    <a
                      data-interaction="conversation_all_chat_tab"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        onSelectConversation(user);
                      }}
                    >
                      <div className="d-flex align-items-top">
                        <div className="me-1 lh-1">
                          <span
                            className={`avatar avatar-md me-2 avatar-rounded ${user.status}`}
                          >
                            <img
                              src={user.expert.image}
                              alt={user.expert.nickname}
                            />
                          </span>
                        </div>
                        <div className="flex-fill">
                          <p className="mb-0 fw-semibold">
                            {user.expert.nickname}
                            {/*  <span className="float-end text-muted fw-normal fs-11">
                              {user.date}
                            </span> */}
                          </p>
                          <p className="fs-12 mb-0">
                            <span
                              className="chat-msg text-truncate"
                              style={
                                user.last_message.seen === false
                                  ? { fontWeight: "bold" }
                                  : {}
                              }
                            >
                              {user.last_message.content}
                            </span>
                            <span className="chat-read-icon float-end align-middle text-muted">
                              {languageData.send}
                            </span>
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                ))
              ) : (
               <div className="d-flex flex-column align-items-center justify-content-center p-6">
                  <div class="empty_message">
                    <svg
                      width="80"
                      height="80"
                      viewBox="0 0 80 80"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <circle cx="40" cy="40" r="36" fill="#F3F0FF"></circle>
                      <rect
                        x="18"
                        y="24"
                        width="32"
                        height="20"
                        rx="9"
                        fill="#ffffff"
                        stroke="#7C3AED"
                        stroke-width="1.4"
                      ></rect>
                      <circle
                        cx="27"
                        cy="34"
                        r="2.2"
                        fill="#7C3AED"
                        opacity=".4"
                      ></circle>
                      <circle
                        cx="34"
                        cy="34"
                        r="2.2"
                        fill="#7C3AED"
                        opacity=".4"
                      ></circle>
                      <circle
                        cx="41"
                        cy="34"
                        r="2.2"
                        fill="#7C3AED"
                        opacity=".4"
                      ></circle>
                      <path
                        d="M24 44l-4 6 8-3"
                        fill="#ffffff"
                        stroke="#7C3AED"
                        stroke-width="1.3"
                        stroke-linejoin="round"
                      ></path>
                      <rect
                        x="34"
                        y="46"
                        width="26"
                        height="16"
                        rx="8"
                        fill="#EDE9FE"
                        stroke="#7C3AED"
                        stroke-width="1.4"
                      ></rect>
                      <circle
                        cx="42"
                        cy="54"
                        r="1.8"
                        fill="#7C3AED"
                        opacity=".5"
                      ></circle>
                      <circle
                        cx="47"
                        cy="54"
                        r="1.8"
                        fill="#7C3AED"
                        opacity=".5"
                      ></circle>
                      <circle
                        cx="52"
                        cy="54"
                        r="1.8"
                        fill="#7C3AED"
                        opacity=".5"
                      ></circle>
                      <path
                        d="M56 62l4 5-7-2"
                        fill="#EDE9FE"
                        stroke="#7C3AED"
                        stroke-width="1.3"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <span class="empty_message_title">
                      {languageData.no_message}
                    </span>
                  </div>
                </div>
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeftCard;
